import React, { useState } from "react";
import {
  Box,
  HStack,
  IconButton,
  Tooltip,
  FormControl,
  FormLabel,
  Switch,
  Input,
  VStack,
  Text,
  Button,
  List,
  ListItem,
} from "@chakra-ui/react";
import {
  DeleteIcon,
  CopyIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  CloseIcon,
} from "@chakra-ui/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function DraggableRankingDropdownRadiogroupCheckboxCreationElement({
  element,
  name,
  onDelete,
  onCopy,
  onMoveUp,
  onMoveDown,
  onChangeData,



  isMatrixDropdownElement,
  onDeleteMatrixDropdown,
  
  onCopyMatrixDropdown,
  onMoveUpMatrixDropdown,
  onMoveDownMatrixDropdown
  
}) {
  const {t} = useTranslation();
  useEffect(() => {
    
    if (element.isRequired == null) {
      onChangeData(element.id, "isRequired", false);
    }

    
  }, [element, onChangeData]);


  const [newChoice, setNewChoice] = useState("");

  const [choices , setChoices] = useState(element.choices || [])


  


  const handleAddChoice = () => {
    const trimmedChoice = newChoice.trim();
    if (trimmedChoice !== "" && !choices.includes(trimmedChoice)) {
      const updatedChoices = [...choices, trimmedChoice]; // Calcola l'array aggiornato
      setChoices(updatedChoices); // Aggiorna lo stato locale
      onChangeData(element.id, "choices", updatedChoices); // Passa l'array aggiornato al genitore
      setNewChoice(""); // Resetta il valore del campo di input
    }
  };
  
  const handleRemoveChoice = (choiceToRemove) => {
    const updatedChoices = choices.filter((choice) => choice !== choiceToRemove); // Calcola l'array aggiornato
    setChoices(updatedChoices); // Aggiorna lo stato locale
    onChangeData(element.id, "choices", updatedChoices); // Passa l'array aggiornato al genitore
  };
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      p={4}
      shadow="sm"
      position="relative"
      width="100%"
    >
      
      {/* Pulsanti di azione */}
      <HStack spacing={2} position="absolute" top={2} left={2}>
        <Text fontWeight="bold" fontSize="md">
          {name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()} {t('survey.dropRadioCheckQuestion.question')}
        </Text>
      

         {!element.disabled && (
               <Tooltip label={t('survey.iconQuestion.delete')} fontSize="sm">
               <IconButton
                 size="sm"
                 aria-label="Elimina"
                 icon={<DeleteIcon />}
                 onClick={()=> { isMatrixDropdownElement ? onDeleteMatrixDropdown(): onDelete()}}
               />
             </Tooltip>  )}


             {!element.disabled && (
              <Tooltip label={t('survey.iconQuestion.copy')} fontSize="sm">
              <IconButton
                size="sm"
                aria-label="Copia"
                icon={<CopyIcon />}
                onClick={()=> { isMatrixDropdownElement ? onCopyMatrixDropdown(): onCopy()}}
              />
            </Tooltip>  )}
      
        
        <Tooltip label={t('survey.iconQuestion.moveUp')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label={t('survey.iconQuestion.moveDown')}
            icon={<ArrowUpIcon />}
            onClick={()=> { isMatrixDropdownElement ? onMoveUpMatrixDropdown(): onMoveUp()}}
          />
        </Tooltip>
        <Tooltip label="Sposta giù" fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Sposta giù"
            icon={<ArrowDownIcon />}
            onClick={()=> { isMatrixDropdownElement ? onMoveDownMatrixDropdown(): onMoveDown()}}
          />
        </Tooltip>
      </HStack>

      {/* Dettagli dell'elemento del form */}
      <VStack mt={8} align="start" spacing={4}>
       

        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.dropRadioCheckQuestion.title')}</FormLabel>
          <Input
            value={element.title}
            isDisabled={element.disabled}
            placeholder={t('survey.dropRadioCheckQuestion.enterTitle')}
            onChange={(e) => onChangeData(element.id,"title", e.target.value)}
          />
        </FormControl>

         {/* Name */}
         <FormControl>
          <FormLabel fontWeight="bold">{t('survey.dropRadioCheckQuestion.tag')}</FormLabel>
          <Input
            value={element.name}
            isDisabled={element.disabled}
            placeholder={t('survey.dropRadioCheckQuestion.enterTag')}
            onChange={(e) => onChangeData(element.id, "name", e.target.value)}
          />
         </FormControl>

        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.dropRadioCheckQuestion.options')}</FormLabel>
          <VStack align="start" spacing={2} width="100%">
          
            <HStack width="100%">
              <Input
                value={newChoice}
                isDisabled={element.disabled}
                placeholder={t('survey.dropRadioCheckQuestion.addNewOption') + name}
                onChange={(e) => setNewChoice(e.target.value) }
                onKeyDown ={(e) => {
                  if (e.key === "Enter") {
                    handleAddChoice();
                  }
                }}
              />
              <Button  isDisabled={element.disabled} onClick={handleAddChoice}>{t('survey.dropRadioCheckQuestion.add')}</Button>
            </HStack>

            <List spacing={2} width="100%">
              {choices.map((choice, index) => (
                <ListItem
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="md"
                  p={2}
                >
                  <Text>{choice}</Text>
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    isDisabled={element.disabled}
                    aria-label="Rimuovi opzione"
                    onClick={() => handleRemoveChoice(choice)}
                  />
                </ListItem>
              ))}
            </List>
          </VStack>
        </FormControl>

       

        <FormControl display="flex" alignItems="center">
          <FormLabel mb="0" fontWeight="bold">
          {t('survey.dropRadioCheckQuestion.required')}
          </FormLabel>
          <Switch
            isChecked={element.isRequired}
            isDisabled={element.disabled}
            onChange={(e) => onChangeData(element.id,"isRequired", e.target.checked)}
          />
        </FormControl>
      </VStack>
    </Box>
  );
}

export default DraggableRankingDropdownRadiogroupCheckboxCreationElement;
